import { html } from "lit";
import { renderStandardPictureElement } from "../../../../utils";

interface TeaserStoryProps {
    date?: string;
    storyTitle?: string;
    linkUrl?: string;
    storyLabel?: string;
    videoLabel?: string;
    isInSlider?: boolean;
}

export const dummyStory: TeaserStoryProps = {
    date: "12.07.2012",
    storyTitle: "So will TRUMPF die Liferzeiten für Ersatzteile halbieren",
    linkUrl: "#",
    storyLabel: "",
    videoLabel: "",
    isInSlider: false,
};

export const dummyStories: TeaserStoryProps[] = [
    {
        ...dummyStory,
    },
    {
        ...dummyStory,
        storyTitle: "Veritatis et quasi architecto beatae vitae dicta",
        storyLabel: "Industrie 4.0",
        videoLabel: null,
    },
    {
        ...dummyStory,
        storyTitle: "Sed ut perspiciatis unde omnis iste",
        storyLabel: null,
    },
    {
        ...dummyStory,
        storyTitle: "natus error sit voluptatem accusantium omnis iste",
        storyLabel: "news",
    },
    {
        ...dummyStory,
        storyTitle: "totam rem aperiam, eaque ipsa quae ab illo inventore",
        videoLabel: null,
    },
    {
        ...dummyStory,
        storyTitle: "veritatis et quasi architecto beatae vitae dicta",
        storyLabel: "news",
    },
    {
        ...dummyStory,
        storyTitle: "Nemo enim ipsam voluptatem quia voluptas",
        storyLabel: null,
        videoLabel: null,
    },
    {
        ...dummyStory,
        storyTitle: "Sed quia consequuntur magni dolores voluptatem",
    },
    {
        ...dummyStory,
        storyTitle: "Neque porro quisquam est magni dolores",
        storyLabel: null,
    },
];

const renderStoryTag = (label: string) =>
    html`<ux-tag disabled>${label}</ux-tag>`;

const renderVideoTag = (label: string) => html`
    <div class="ux-iws-teaser-story__tag ux-iws-teaser-story__tag--green">
        <ux-icon name="play-rounded"></ux-icon>
        ${label}
    </div>
`;

const renderTags = ({ storyLabel, videoLabel }: TeaserStoryProps) => {
    if (!storyLabel && !videoLabel) {
        return html``;
    }
    return html`
        <!-- BEGIN optional tag container -->
        <div class="ux-iws-teaser-story__tag-container">
            ${storyLabel && renderStoryTag(storyLabel)}
            ${videoLabel && renderVideoTag(videoLabel)}
        </div>
        <!-- END optional tag container -->
    `;
};

export const TeaserStoryTemplate = ({
    date = "12.07.2012",
    storyTitle = "So will TRUMPF die Liferzeiten für Ersatzteile halbieren",
    linkUrl = "#",
    storyLabel = "",
    videoLabel = "",
}: TeaserStoryProps) => {
    return html`
        <ux-iws-link-wrapper class="ux-iws-teaser-story">
            <div class="ux-iws-teaser-story__image-container">
                ${renderStandardPictureElement({
                    width: 600,
                    height: 396,
                })}
            </div>
            <div class="ux-iws-teaser-story__content">
                <div class="ux-iws-teaser-story__info">
                    ${renderTags({ storyLabel, videoLabel })}
                    ${
                        date !== ""
                            ? html` <div
                                  class="ux-text-tiny ux-text-tiny--bold ux-u-margin-bottom-10"
                              >
                                  ${date}
                              </div>`
                            : ""
                    }
                    <ux-text-lines-limit text-lines-xl="3" text-lines-l="2" text-lines-m="2" text-lines-s="2">
                        <h4 class="ux-text-title-teaser ux-u-margin-vertical-0">
                            ${storyTitle}
                        </h4>
                    </ux-text-lines-limit>
                    </span>
                </div>
                <div class="ux-iws-teaser-story__cta">
                    <a
                        href="${linkUrl}"
                        class="ux-button ux-button--icon-only"
                        title="next"
                        aria-label="next"
                        role="button"
                    >
                        <ux-icon name="chevron-right"/>
                    </a>
                </div>
            </div>
        </ux-iws-link-wrapper>
    `;
};

export const TeaserStoryListTemplate = () => html`
    <div class="ux-row ux-u-mx-zero">
        ${dummyStories.map(
            (tile) => html`
                <div
                    class="ux-col-12 ux-col-sm-6 ux-col-md-4 ux-u-mb-fluid-xxs"
                >
                    ${TeaserStoryTemplate(tile)}
                </div>
            `
        )}
    </div>
`;
